<template>
    <section class="ad-sec3">
        <div class="ad-sec3-container" :class="{ col }">
            <div class="ad-sec3-txt">
                <h2>{{title}}</h2>
                <p>{{text}}</p>
            </div>
            <div class="ad-sec3-video">
                <div class="iframe-filo"><iframe :src="videoSrc" allowFullScreen="true" webkitAllowFullscreen="true" mozAllowFullscreen="true"  scrolling="no"></iframe></div>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    name: "AdSection3",
    props: {
        col: {
          type: Boolean,
          default: false
        },

        title: {
          type: String,
          required: true
        },
        text: {
          type: String,
          required: true
        },
        videoSrc: {
          type: String,
          required: true
        },
      },
    setup() {

        return {

        }

    }
};
</script>

<style scoped>
.col {
    flex-direction: column-reverse;
}

.ad-sec3 {
    width: 100%;
}

.ad-sec3-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    column-gap: 5.23%;
    row-gap: 24px;
    padding-block: 2.639%;
    margin-inline: 12.37%;
    width: calc(100% - 24.74%);
}

.ad-sec3-txt {
    flex-grow: 1;
    animation: fadeIn 3s ease-out forwards;
}

.ad-sec3-txt h2 {
    font-family: IRANYekan-Bold;
    font-size: 28px;
    line-height: 38px;
    margin-bottom: 24px;

}

.ad-sec3-txt h2,
.ad-sec3-txt p {
    text-align: justify;
}

.ad-sec3-txt p {
    line-height: 28px;
}

.ad-sec3-video {
    aspect-ratio: 534 / 300;
    width: 50%;
    max-width: 534px;
    max-height: 300px;
    flex-shrink: 0;
}

.iframe-filo {
    height: 100%;
}

.ad-sec3-video iframe {
    aspect-ratio: 16/9;
    width: 100%;
    height: 100%;
    border-radius: 20px;
    box-shadow: 0 0 10px var(--shadow-light);
    border: none;
}

@media screen and (min-width:1441px) {
    .ad-sec3-container {
        width: 1145px;
        padding-block: 38px;
        margin-inline: auto;
    }
}

@media screen and (max-width:1024px) {
    .ad-sec3-container {
        margin-inline: 5.556%;
        width: calc(100% - 11.112%);
    }

    .ad-sec3-txt h2 {
        font-size: 24px;
         line-height: 28px;
    }

    .ad-sec3-txt p {
        line-height: 26px;
    }

    .ad-sec3-video {
        width: 50%;
    }

    .col .ad-sec3-video {
        width: 70%;
    }
}

@media screen and (max-width: 768px) {
    .ad-sec3-container {
        flex-direction: column-reverse;
        margin-inline: 9.03%;
        width: calc(100% - 18.06%);
    }

    .ad-sec3-txt h2 {
        margin-bottom: 16px;
    }

    .ad-sec3-video {
        width: 295px;
        height: 165px;
    }

    .col .ad-sec3-video {
        width: 100%;
        height: unset;
    }
}

@media screen and (max-width: 576px) {
    .col {
        row-gap: 16px;
    }
}

@media screen and (max-width: 375px) {
    .ad-sec3-txt h2 {
        font-size: 20px;
    }

    .ad-sec3-txt p {
        font-size: 16px;
    }
}
</style>